import React, { useEffect, useState, useRef } from "react";
import "./positionmap.css";
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import { FaChartBar } from "react-icons/fa";
import { FaTableCells } from "react-icons/fa6";
import { IoMdPlayCircle } from "react-icons/io";
import { MdOutlineRefresh } from "react-icons/md";
import {
    fetchDayAheadEntitlement, fetchDaEntSummary, fetchDaMinSchedule, fetchPositionMap, fetchMinSchPositionMap, fetchDaMod, fetchDaReplacementOpp,
    commitDaReplacementTrade, fetchDaSalesTradeMaster, fetchCurrentScheduleMaster, fetchCurrentCapacityOverMin, fetchCurrentRampCapacityMaster, fetchLoadModel,
    fetchWindModel, fetchSolarModel, fetchPriceModel, deleteEntitlement
} from './api';
import Table from "./table";
import Charts from "./charts";
import * as d3 from "d3";
import StackedBarCharts from "./stackedBarCharts";
import CombinationCharts from "./combinationCharts";
import { MdCloudUpload } from "react-icons/md";
import TradeTable from "./tradeTable";
import {
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    IconButton
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const Positionmap = () => {
    const defaultTransactionCost = "0.0236";
    const defaultTradingMargin = "0.2";
    const [openDropdown, setOpenDropdown] = useState(null);
    const [selectedOption, setSelectedOption] = useState("Day-Ahead");
    const [selectedMapOption, setSelectedMapOption] = useState("Position map");
    const [showTable, setShowTable] = useState(true);
    const dropdownRef = useRef(null);
    const options = ["Day-Ahead", "Intra-day"];
    // const mapOptions = [
    //     "Position map", "Schedule Master", "Schedule Summary", "Capacity over min",
    //     "Total Min Schedule", "mustsch_positionmap", "Ramp_Capacity_master", "Merit Order ramp Up/Down",
    //     "Trade"
    // ];
    const mapOptions0D = [
        "Position map", "Schedule Master", "Schedule Summary", "Capacity over min",
        "Total Min Schedule", "mustsch_positionmap", "Ramp_Capacity_master",
        "Merit Order ramp Up/Down", "Trade"
    ];

    const mapOptions1D = [
        "Position map", "Entitilement", "Entitilement Summary",
        "Total Min Schedule", "mustsch_positionmap",
        "Merit Order schedule", "Trade"
    ];

    const getTodayInIST = () => {
        const now = new Date();

        const istOffset = 5.5 * 60 * 60 * 1000;
        const istDate = new Date(now.getTime() + istOffset);

        return istDate.toISOString().split("T")[0];
    };

    const getTomorrowInIST = () => {
        const now = new Date();

        const istOffset = 5.5 * 60 * 60 * 1000;
        const istDate = new Date(now.getTime() + istOffset);

        istDate.setDate(istDate.getDate() + 1);
        return istDate.toISOString().split("T")[0];
    };

    const tableRef = useRef(null);
    const chartRef = useRef(null);
    const [headers, setHeaders] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [xData, setXData] = useState([]);
    const [yData, setYData] = useState([]);
    const [selectedDate, setSelectedDate] = useState(getTodayInIST());
    const [loadModels, setLoadModels] = useState([]);
    const [priceModels, setPriceModels] = useState([]);
    const [solarModels, setSolarModels] = useState([]);
    const [windModels, setWindModels] = useState([]);
    const [showSettingModal, setShowSettingModal] = useState(false);
    const [selectedTradeTab, setSelectedTradeTab] = useState(0);
    const [isTransposed, setIsTransposed] = useState(false);
    const [rawTradeData, setRawTradeData] = useState([]);
    const [currentView, setCurrentView] = useState('view1');
    const [poolOptions, setPoolOptions] = useState([]);
    const [entitlementResponse, setEntitlementResponse] = useState(null);
    const [entitlementSummaryResponse, setEntitlementSummaryResponse] = useState(null);
    const [totalMinSchResponse, setToalMinSchResponse] = useState(null);
    const [rampCapacityMasterResponse, setRampCapacityMasterResponse] = useState(null);
    const [selectedLoadModel, setSelectedLoadModel] = useState(() => localStorage.getItem("selectedLoadModel") || "");
    const [selectedPriceModel, setSelectedPriceModel] = useState(() => localStorage.getItem("selectedPriceModel") || "");
    const [selectedSolarModel, setSelectedSolarModel] = useState(() => localStorage.getItem("selectedSolarModel") || "");
    const [selectedWindModel, setSelectedWindModel] = useState(() => localStorage.getItem("selectedWindModel") || "");
    const [transactionCost, setTransactionCost] = useState(() => localStorage.getItem("transactionCost") || defaultTransactionCost);
    const [tradingMargin, setTradingMargin] = useState(() => localStorage.getItem("tradingMargin") || defaultTradingMargin);
    const [timeRange, setTimeRange] = useState("0D");
    const [tempLoadModel, setTempLoadModel] = useState("");
    const [tempPriceModel, setTempPriceModel] = useState("");
    const [tempSolarModel, setTempSolarModel] = useState("");
    const [tempWindModel, setTempWindModel] = useState("");
    const [tempTransactionCost, setTempTransactionCost] = useState("");
    const [tempTradingMargin, setTempTradingMargin] = useState("");
    const [loading, setLoading] = useState(false);
    const [statusMessage, setStatusMessage] = useState('');
    const [messageType, setMessageType] = useState('');

    useEffect(() => {
        fetchAllForecastModels();
    }, []);

    useEffect(() => {
        setHeaders([]);
        setTableData([]);
        setPoolOptions([]);
        setXData([]);
        setYData([]);
    }, [selectedMapOption]);

    useEffect(() => {
        if (showSettingModal) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [showSettingModal]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpenDropdown(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (statusMessage) {
            const timer = setTimeout(() => {
                setStatusMessage('');
            }, 3000);

            return () => clearTimeout(timer);
        }
    }, [statusMessage]);

    useEffect(() => {
        if (!selectedMapOption || !selectedDate) return;

        setHeaders([]);
        setTableData([]);
        setXData([]);
        setYData([]);

        if (selectedMapOption === "Trade") {
            fetchTradeData();
        } else {
            fetchData();
        }
    }, [selectedMapOption, selectedDate]);

    const handleSelect = (option, type) => {
        if (type === "market") {
            setSelectedOption(option);
        } else {
            setSelectedMapOption(option);
        }
        setOpenDropdown(null);
    };

    const toggleDropdown = (type) => {
        setOpenDropdown(openDropdown === type ? null : type);
    };

    const openSettingsModal = () => {
        setTempLoadModel(selectedLoadModel || (loadModels.length === 1 ? loadModels[0] : ""));
        setTempPriceModel(selectedPriceModel || (priceModels.length === 1 ? priceModels[0] : ""));
        setTempSolarModel(selectedSolarModel || (solarModels.length === 1 ? solarModels[0] : ""));
        setTempWindModel(selectedWindModel || (windModels.length === 1 ? windModels[0] : ""));
        setTempTransactionCost(transactionCost || defaultTransactionCost);
        setTempTradingMargin(tradingMargin || defaultTradingMargin);
        setShowSettingModal(true);
    };

    const handleNumericInput = (e, field) => {
        let value = e.target.value;
        value = value.replace(/[^0-9.]/g, '');
        const parts = value.split('.');
        if (parts.length > 2) {
            value = parts[0] + '.' + parts.slice(1).join('');
        }

        if (field === "transactionCost") {
            setTransactionCost(value);
            localStorage.setItem("transactionCost", value);
        } else if (field === "tradingMargin") {
            setTradingMargin(value);
            localStorage.setItem("tradingMargin", value);
        }
    };

    const handleSaveSettings = () => {
        setSelectedLoadModel(tempLoadModel);
        setSelectedPriceModel(tempPriceModel);
        setSelectedSolarModel(tempSolarModel);
        setSelectedWindModel(tempWindModel);
        setTransactionCost(tempTransactionCost);
        setTradingMargin(tempTradingMargin);

        localStorage.setItem("selectedLoadModel", tempLoadModel);
        localStorage.setItem("selectedPriceModel", tempPriceModel);
        localStorage.setItem("selectedSolarModel", tempSolarModel);
        localStorage.setItem("selectedWindModel", tempWindModel);
        localStorage.setItem("transactionCost", tempTransactionCost);
        localStorage.setItem("tradingMargin", tempTradingMargin);

        setShowSettingModal(false);
    };

    const handleTempNumericInput = (e, setter) => {
        let value = e.target.value.replace(/[^0-9.]/g, '');
        const parts = value.split('.');
        if (parts.length > 2) value = parts[0] + '.' + parts.slice(1).join('');
        setter(value);
    };

    const getTomorrowDate = () => {
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        return tomorrow.toISOString().split("T")[0];
    };

    const processJsonsData = (data) => {
        // console.log(data);
        if (!Array.isArray(data) || data.length === 0) {
            //    console.error("Invalid or empty data format");
            return;
        }

        setHeaders([]);
        setTableData([]);
        setXData?.([]);
        setYData?.([]);

        const firstRow = data[0];
        const groupKeys = ['date', 'block_no'];
        const dynamicKeys = new Set();
        let chartType = "default";

        if ('pool' in firstRow) groupKeys.push('pool');

        if ('unit_name' in firstRow) {
            data.forEach(row => row.unit_name && dynamicKeys.add(row.unit_name));
        } else if ('plant_type' in firstRow) {
            data.forEach(row => row.plant_type && dynamicKeys.add(row.plant_type));
        } else if ('series' in firstRow) {
            data.forEach(row => row.series && dynamicKeys.add(row.series));
            chartType = "combination";
        }

        const groupedMap = new Map();
        const nonEditableColumns = new Set(["Date", "Block No", "block_no"]);

        data.forEach(row => {
            const dateValue = typeof row.date === "string" && row.date.includes("T")
                ? row.date.split("T")[0]
                : row.date;

            const keyParts = [dateValue];
            if (row.block_no !== undefined) keyParts.push(row.block_no);
            if (row.pool !== undefined) keyParts.push(row.pool);
            const key = keyParts.join('|');

            if (!groupedMap.has(key)) {
                const baseObj = {
                    date: dateValue,
                    ...(row.block_no !== undefined && { block_no: row.block_no }),
                    ...(row.pool !== undefined && { pool: row.pool }),
                };
                groupedMap.set(key, baseObj);
            }

            const currentRow = groupedMap.get(key);

            if (row.unit_name) {
                currentRow[row.unit_name] = Number(row.entitlement || row.min_schedule) || 0;
            } else if (row.plant_type) {
                currentRow[row.plant_type] = Number(row.schedule_mw) || 0;
            } else if (row.series) {
                currentRow[row.series] = Number(row.total) || 0;
            }
        });

        const processedData = Array.from(groupedMap.values());

        processedData.sort((a, b) => {
            const dateA = new Date(a.date), dateB = new Date(b.date);
            if (dateA - dateB !== 0) return dateA - dateB;
            if (a.block_no - b.block_no !== 0) return a.block_no - b.block_no;
            return (a.rev_no || 0) - (b.rev_no || 0);
        });

        const headersWithMetadata = groupKeys.map(key => ({
            name: key,
            dataType: key === "block_no" ? "number" : "text",
            editable: true,
            width: 120,
            displayName: key.replace(/_/g, " ").replace(/\b\w/g, l => l.toUpperCase()),
        }))
            .concat(Array.from(dynamicKeys).map(key => ({
                name: key,
                dataType: "number",
                editable: !nonEditableColumns.has(key),
                width: 120,
                displayName: key,
            })));

        setHeaders(headersWithMetadata);
        setTableData(processedData);
        const fieldNames = headersWithMetadata.map(h => h.name);

        if (chartType === "combination") {
            prepareCombinationChartData?.(processedData, fieldNames);
        } else {
            prepareChartData?.(processedData, fieldNames);
        }
    };

    const processCapacityOverMinData = (data) => {
        if (!Array.isArray(data) || data.length === 0) {
            // console.error("Invalid or empty data format");
            return;
        }

        const groupKeys = ['date', 'block_no'];
        const groupedMap = new Map();
        const unitNames = new Set();
        let valueKey = null;
        const nonEditableColumns = new Set(["Date", "Block No", "block_no"]);

        const sampleRow = data[0];
        for (const key of Object.keys(sampleRow)) {
            if (!groupKeys.includes(key) && key !== 'datetime' && key !== 'unit_name') {
                const val = Number(sampleRow[key]);
                if (!isNaN(val)) {
                    valueKey = key;
                    break;
                }
            }
        }

        if (!valueKey) {
            //    console.error("No numeric value field found in data");
            return;
        }

        data.forEach(row => {
            const date = row.date?.split("T")[0] || row.date;
            const block = row.block_no;
            const unit = row.unit_name;
            const value = Number(row[valueKey]) || 0;

            if (!unit) return;

            const key = `${date}|${block}`;
            if (!groupedMap.has(key)) {
                groupedMap.set(key, { date, block_no: block });
            }

            groupedMap.get(key)[unit] = value;
            unitNames.add(unit);
        });

        const headers = [
            { name: "date", dataType: "text", editable: true, displayName: "Date", width: 120 },
            { name: "block_no", dataType: "number", editable: true, displayName: "Block No", width: 100 },
            ...Array.from(unitNames).map(unit => ({
                name: unit,
                dataType: "number",
                editable: !nonEditableColumns.has(unit),
                displayName: unit,
                width: 120
            }))
        ];

        const tableData = Array.from(groupedMap.values());
        tableData.sort((a, b) => {
            const dateA = new Date(a.date), dateB = new Date(b.date);
            if (dateA - dateB !== 0) return dateA - dateB;
            if (a.block_no - b.block_no !== 0) return a.block_no - b.block_no;
            return (a.rev_no || 0) - (b.rev_no || 0);
        });
        setHeaders(headers);
        setTableData(tableData);

        if (typeof prepareChartData === 'function') {
            const fieldNames = headers.map(h => h.name);
            prepareChartData(tableData, fieldNames);
        }
    };

    // const handleViewToggle = () => {
    //     setShowTable(!showTable);

    //     if (showTable) {
    //         const tableData = tableRef.current?.getUpdatedData?.();
    //         if (tableData && tableData.length > 0) {
    //             const fieldNames = Object.keys(tableData[0]);
    //             if (selectedMapOption === "Position map") {
    //                 prepareCombinationChartData?.(tableData, fieldNames);
    //             } else {
    //                 prepareChartData?.(tableData, fieldNames);
    //             }
    //         } else {
    //             console.log("No table data available.");
    //         }
    //     } 
    //     else {
    //         const chartData = chartRef.current?.getUpdatedChartData?.();
    //     console.log("chartData", chartData);
    //         if (chartData && chartData.length > 0) {
    //             const transformedData = [];
    //             const date = new Date().toISOString();

    //             if (selectedMapOption === "mustsch_positionmap") {
    //                 chartData.forEach(row => {
    //                     transformedData.push({ ...row });
    //                 });

    //                 processJsonData(transformedData);
    //             } else {
    //                 // ✅ For all others, transform into series/total format
    //                 chartData.forEach((item) => {
    //                     const { field, values } = item;

    //                     if (field === 'originalRowIndex') return;

    //                     if (Array.isArray(values)) {
    //                         values.forEach((value, blockNo) => {
    //                             transformedData.push({
    //                                 series: field,
    //                                 date: date,
    //                                 block_no: blockNo + 1,
    //                                 total: value?.toString(),
    //                             });
    //                         });
    //                     } else if (typeof values === 'object' && values !== null) {
    //                         Object.entries(values).forEach(([key, val], i) => {
    //                             transformedData.push({
    //                                 series: `${field}-${key}`,
    //                                 date: date,
    //                                 block_no: i + 1,
    //                                 total: val?.toString(),
    //                             });
    //                         });
    //                     } else {
    //                         console.warn("Unknown structure in 'values'.", item);
    //                     }
    //                 });

    //                 // ✅ Now handle based on selected map
    //                 if (selectedMapOption === "Position map") {
    //                     processJsonsData(transformedData);
    //                 }
    //                 else if (selectedMapOption === "Schedule Master" ||
    //                          selectedMapOption === "Total Min Schedule" ||
    //                          selectedMapOption === "Schedule Summary") {
    //                     processJsonPoolData(transformedData, "ALL");
    //                 }
    //                 else if (selectedMapOption === "Merit Order ramp Up/Down") {
    //                     processMerirOrderJsonData(transformedData);
    //                 }
    //                 else if (selectedMapOption === "Trade") {
    //                     if (isTransposed) {
    //                         processTradeDataView2(transformedData);
    //                         setCurrentView("view2");
    //                     } else {
    //                         processTradeData(transformedData);
    //                         setCurrentView("view1");
    //                     }
    //                 }
    //             }
    //         } else {
    //             console.log("No chart data available.");
    //         }
    //     }

    // };

    const processJsonPoolData = (data, selectedPool) => {
        if (!Array.isArray(data) || data.length === 0) {
            //     console.error("Invalid or empty data format");
            return;
        }

        setHeaders([]);
        setTableData([]);
        setXData?.([]);
        setYData?.([]);

        const firstRow = data[0];
        const groupKeys = ['date', 'block_no'];
        const dynamicKeys = new Set();
        let chartType = "default";

        const hasPool = 'pool' in firstRow;

        const filteredData = selectedPool === "ALL"
            ? data
            : data.filter(row => row.pool === selectedPool);

        if (hasPool && selectedPool !== "ALL") {
            groupKeys.push('pool');
        }

        if ('unit_name' in firstRow) {
            filteredData.forEach(row => row.unit_name && dynamicKeys.add(row.unit_name));
        } else if ('plant_type' in firstRow) {
            filteredData.forEach(row => {
                if (row.plant_type) {
                    const key = selectedPool === "ALL" && row.pool
                        ? `${row.pool}_${row.plant_type}`
                        : row.plant_type;
                    dynamicKeys.add(key);
                }
            });
        } else if ('series' in firstRow) {
            filteredData.forEach(row => row.series && dynamicKeys.add(row.series));
            chartType = "combination";
        }

        const groupedMap = new Map();
        const nonEditableColumns = new Set(["Date", "Block No", "block_no"]);

        filteredData.forEach(row => {
            const dateValue = typeof row.date === "string" && row.date.includes("T")
                ? row.date.split("T")[0]
                : row.date;

            const keyParts = [dateValue];
            if (row.block_no !== undefined) keyParts.push(row.block_no);
            if (hasPool && selectedPool !== "ALL" && row.pool !== undefined) {
                keyParts.push(row.pool);
            }

            const key = keyParts.join('|');

            if (!groupedMap.has(key)) {
                const baseObj = {
                    date: dateValue,
                    ...(row.block_no !== undefined && { block_no: row.block_no }),
                    ...(hasPool && selectedPool !== "ALL" && row.pool !== undefined && { pool: row.pool }),
                };
                groupedMap.set(key, baseObj);
            }

            const currentRow = groupedMap.get(key);

            if (row.unit_name) {
                currentRow[row.unit_name] = Number(row.entitlement || row.min_schedule) || 0;
            } else if (row.plant_type) {
                const key = selectedPool === "ALL" && row.pool
                    ? `${row.pool}_${row.plant_type}`
                    : row.plant_type;
                currentRow[key] = Number(row.schedule_mw) || Number(row.schedule) || 0;
            } else if (row.series) {
                currentRow[row.series] = Number(row.total) || 0;
            }
        });

        const processedData = Array.from(groupedMap.values());

        processedData.sort((a, b) => {
            const dateA = new Date(a.date), dateB = new Date(b.date);
            if (dateA - dateB !== 0) return dateA - dateB;
            if (a.block_no - b.block_no !== 0) return a.block_no - b.block_no;
            return (a.rev_no || 0) - (b.rev_no || 0);
        });

        const headersWithMetadata = groupKeys.map(key => ({
            name: key,
            dataType: key === "block_no" ? "number" : "text",
            editable: !nonEditableColumns.has(key),
            width: 120,
            displayName: key.replace(/_/g, " ").replace(/\b\w/g, l => l.toUpperCase()),
        })).concat(Array.from(dynamicKeys).map(key => ({
            name: key,
            dataType: "number",
            editable: !nonEditableColumns.has(key),
            width: 120,
            displayName: key,
        })));

        setHeaders(headersWithMetadata);
        setTableData(processedData);

        const fieldNames = headersWithMetadata.map(h => h.name);
        if (chartType === "combination") {
            prepareCombinationChartData?.(processedData, fieldNames);
        } else {
            prepareChartData?.(processedData, fieldNames);
        }
    };

    const processRampPoolData = (data, selectedKeyOrPool) => {
        if (!Array.isArray(data) || data.length === 0) {
            //   console.error("Invalid or empty data format");
            return;
        }

        setHeaders([]);
        setTableData([]);
        setXData?.([]);
        setYData?.([]);

        const metaKeys = ['date', 'block_no'];
        const excludeKeys = new Set(['unit_name', 'variable_cost', 'datetime', 'pool']);
        const nonEditableColumns = new Set(["Date", "Block No", "block_no"]);

        const allDynamicKeys = new Set();
        data.forEach(row => {
            Object.keys(row).forEach(key => {
                if (!metaKeys.includes(key) && !excludeKeys.has(key)) {
                    allDynamicKeys.add(key);
                }
            });
        });

        const isSelectedKeyDynamic = allDynamicKeys.has(selectedKeyOrPool);
        const isSelectedAll = selectedKeyOrPool === "ALL";

        let filteredData;
        if (isSelectedAll) {
            filteredData = data;
        } else if (isSelectedKeyDynamic) {
            filteredData = data;
        } else {
            filteredData = data.filter(row => row.pool === selectedKeyOrPool);
        }

        const dynamicKeysToUse = isSelectedKeyDynamic
            ? new Set([selectedKeyOrPool])
            : allDynamicKeys;

        const groupedMap = new Map();

        filteredData.forEach(row => {
            let dateValue = "";
            if (row.date) {
                const dt = new Date(row.date);
                const yyyy = dt.getFullYear();
                const mm = String(dt.getMonth() + 1).padStart(2, "0");
                const dd = String(dt.getDate()).padStart(2, "0");
                dateValue = `${yyyy}-${mm}-${dd}`;
            }

            const groupKey = `${dateValue}|${row.block_no ?? ''}`;

            if (!groupedMap.has(groupKey)) {
                groupedMap.set(groupKey, {
                    date: dateValue,
                    block_no: row.block_no ?? '',
                });
            }

            const groupedRow = groupedMap.get(groupKey);

            dynamicKeysToUse.forEach(dynamicKey => {
                if (!row.unit_name) return;

                const colName = `${row.unit_name}_${dynamicKey}`;
                const value = Number(row[dynamicKey]) || 0;

                if (groupedRow[colName] === undefined) {
                    groupedRow[colName] = value;
                } else {
                    groupedRow[colName] += value;
                }
            });
        });

        const processedData = Array.from(groupedMap.values());
        const headers = metaKeys.map(key => ({
            name: key,
            dataType: key === 'block_no' ? 'number' : 'text',
            editable: true,
            width: 120,
            displayName: key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()),
        }));

        const dynamicCols = new Set();
        processedData.forEach(row => {
            Object.keys(row).forEach(k => {
                if (!metaKeys.includes(k)) {
                    dynamicCols.add(k);
                }
            });
        });

        Array.from(dynamicCols).sort().forEach(key => {
            headers.push({
                name: key,
                dataType: 'number',
                editable: !nonEditableColumns.has(key),
                width: 120,
                displayName: key,
            });
        });

        processedData.sort((a, b) => {
            const dateA = new Date(a.date);
            const dateB = new Date(b.date);
            if (dateA - dateB !== 0) return dateA - dateB;

            if (a.block_no !== undefined && b.block_no !== undefined) {
                return a.block_no - b.block_no;
            }
            return 0;
        });

        setHeaders(headers);
        setTableData(processedData);

        const fieldNames = headers.map(h => h.name);
        prepareChartData?.(processedData, fieldNames);
    };

    const prepareChartData = (data, fields) => {
        if (data.length > 0 && fields.length > 2) {
            const generateTimeSlots = (blocks) => {
                return Array.from({ length: blocks }, (_, i) => {
                    const hours = String(Math.floor(i / 4)).padStart(2, "0");
                    const minutes = String((i % 4) * 15).padStart(2, "0");
                    return `${hours}:${minutes}`;
                });
            };

            const timeSlots = generateTimeSlots(96);
            const xValues = data.map(row => timeSlots[row["block_no"] - 1]);

            const numericFields = fields.filter(
                (field) => field !== "Date" && field !== "block_no" && field !== "rev_no" && field !== "rev_no" && data.some(row => !isNaN(parseFloat(row[field])) && isFinite(row[field]))
            );

            const yValues = numericFields.map((field, index) => ({
                field,
                values: data.map(row => parseFloat(row[field]) || 0),
                color: d3.schemeCategory10[index % 10],
            }));

            setXData(xValues);
            setYData(yValues);
        }
    };

    const prepareCombinationChartData = (data, fields) => {
        if (data.length > 0 && fields.length > 2) {
            const generateTimeSlots = (blocks) => {
                return Array.from({ length: blocks }, (_, i) => {
                    const hours = String(Math.floor(i / 4)).padStart(2, "0");
                    const minutes = String((i % 4) * 15).padStart(2, "0");
                    return `${hours}:${minutes}`;
                });
            };

            const timeSlots = generateTimeSlots(96);
            const xValues = data.map(row => timeSlots[row["block_no"] - 1]);

            const numericFields = fields.filter(
                (field) => field !== "Date" && field !== "block_no" && field !== "rev_no" && data.some(row => !isNaN(parseFloat(row[field])) && isFinite(row[field]))
            );

            const yValues = numericFields.map((field, index) => {
                let type = "stacked";
                let color = d3.schemeCategory10[index % 10];

                if (field === "deficit_surplus") {
                    const hasNegativeValue = data.some(row => parseFloat(row[field]) < 0);
                    type = hasNegativeValue ? "bar" : "stacked";
                } else if (field === "demand") {
                    type = "line";
                    color = "red";
                } else if (field === "total_availability") {
                    type = "line";
                    color = "green";
                }

                if (type === "stacked") {
                    color = `rgba(${d3.rgb(color).r}, ${d3.rgb(color).g}, ${d3.rgb(color).b}, 0.5)`; // Apply 50% transparency
                }

                return {
                    field,
                    type,
                    values: data.map(row => parseFloat(row[field]) || 0),
                    color,
                };
            });

            setXData(xValues);
            setYData(yValues);
        }
    };

    const handlePoolChange = (newPool) => {
        if (selectedMapOption === "Entitilement" && entitlementResponse) {
            const EntitilementData = entitlementResponse.data;
            processJsonPoolData(EntitilementData, newPool);
        }
        if (selectedMapOption === "Entitilement Summary" && entitlementSummaryResponse) {
            const EntitilementSummData = entitlementSummaryResponse.data;
            processJsonPoolData(EntitilementSummData, newPool);
        }
        if (selectedMapOption === "Total Min Schedule" && totalMinSchResponse) {
            const MinData = totalMinSchResponse.data;
            processJsonPoolData(MinData, newPool);
        }
        if (selectedMapOption === "Ramp_Capacity_master" && rampCapacityMasterResponse) {
            const MinData = rampCapacityMasterResponse.data;
            processRampPoolData(MinData, newPool);
        }
    };

    const handleCommit = async () => {
        let updatedData;

        if (showTable) {
            updatedData = tableRef.current?.getUpdatedData?.();
        } else if (chartRef.current?.getUpdatedChartData) {
            updatedData = chartRef.current.getUpdatedChartData();
        } else {
            //  console.warn("No method to fetch updated data from ref.");
            return;
        }

        if (!updatedData) return;

        let formattedData = [];

        if (showTable) {
            const forecastKeys = Object.keys(updatedData[0]).filter(
                key => !["Date", "Block No", "originalRowIndex"].includes(key)
            );

            forecastKeys.forEach(key => {
                updatedData.forEach(row => {
                    formattedData.push([
                        key,
                        row.Date,
                        row["Block No"],
                        row[key] === "null" ? null : row[key]
                    ]);
                });
            });
        } else {
            const currentDate = new Date().toISOString().split("T")[0];

            updatedData.forEach(series => {
                series.values.forEach((value, index) => {
                    formattedData.push([
                        series.field,
                        currentDate,
                        index + 1,
                        value
                    ]);
                });
            });
        }
    };

    const fetchData = async () => {
        if (timeRange === "0D") {
            fetchData0D(timeRange);
        }

        else if (timeRange === "1D") {
            fetchData1D(timeRange);
        }
    }

    const handleDeleteAll = () => {
        if (timeRange === "0D") {
            return;
        }

        try {

            if (selectedMapOption === "Entitilement") {
                // deleteEntitlement(selectedDate)
                //     .then(response => {
                //         console.log(response.data);
                //         setStatusMessage("Data committed successfully!");
                //         setMessageType('success');
                //     })
            }

        } catch (error) {
            console.error("Error in Delete All:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchData1D = async (rangeParam, customDate = null) => {
        setLoading(true);

        try {
            const dateToUse = customDate || selectedDate;
            if (rangeParam === "0D") {
                return;
            }
            try {
                setHeaders([]);
                setTableData([]);
                setXData([]);
                setYData([]);

                const loadModel = selectedLoadModel || "";
                const priceModel = selectedPriceModel || "";
                const solarModel = selectedSolarModel || "";
                const windModel = selectedWindModel || "";

                let response = null;

                switch (selectedMapOption) {
                    case "Position map":
                        response = await fetchPositionMap(dateToUse, solarModel, windModel, loadModel);
                        const positionData = response.data;
                        processJsonsData(positionData);
                        break;

                    case "mustsch_positionmap":
                        response = await fetchMinSchPositionMap(dateToUse, solarModel, windModel, loadModel);
                        const data = response.data;
                        processJsonData(data);
                        break;

                    case "Entitilement":
                        response = await fetchDayAheadEntitlement(dateToUse);
                        setEntitlementResponse(response);
                        fetchPoolDetails(response);
                        const EntitilementData = response.data;
                        processJsonPoolData(EntitilementData, "ALL");
                        break;

                    case "Total Min Schedule":
                        response = await fetchDaMinSchedule(dateToUse, loadModel, priceModel, solarModel, windModel);
                        setToalMinSchResponse(response);
                        fetchPoolDetails(response);
                        const MinData = response.data;
                        processJsonPoolData(MinData, "ALL");
                        break;

                    case "Entitilement Summary":
                        response = await fetchDaEntSummary(dateToUse, loadModel, priceModel, solarModel, windModel);
                        setEntitlementSummaryResponse(response);
                        fetchPoolDetails(response);
                        const EntitilementSummData = response.data;
                        processJsonPoolData(EntitilementSummData, "ALL");
                        break;

                    case "Merit Order schedule":
                        response = await fetchDaMod(dateToUse, solarModel, windModel, loadModel);
                        const meritData = response.data;
                        processMerirOrderJsonData(meritData);
                        break;

                    case "Trade":
                        break;

                    default:
                        //  console.warn("Invalid or unsupported map option selected.");
                        return;
                }

            } catch (error) {
                //  console.error("Error fetching data:", error);
            }
        } catch (error) {
            // console.error("API Error:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchData0D = async (rangeParam, customDate = null) => {
        setLoading(true);

        try {
            const dateToUse = customDate || selectedDate;
            if (rangeParam === "1D") {
                return;
            }
            try {
                setHeaders([]);
                setTableData([]);
                setXData([]);
                setYData([]);

                const loadModel = selectedLoadModel || "";
                const priceModel = selectedPriceModel || "";
                const solarModel = selectedSolarModel || "";
                const windModel = selectedWindModel || "";

                let response = null;

                switch (selectedMapOption) {

                    case "Position map":
                        // response = await fetchPositionMap(dateToUse, solarModel, windModel, loadModel);
                        // const positionData = response.data;
                        // processJsonsData(positionData);
                        break;

                    case "mustsch_positionmap":
                        // response = await fetchMinSchPositionMap(dateToUse, solarModel, windModel, loadModel);
                        // const data = response.data;
                        // processJsonData(data);
                        break;
                    case "Schedule Master":
                        response = await fetchCurrentScheduleMaster(dateToUse);
                        // setEntitlementResponse(response);
                        const EntitilementData = response.data;
                        processScheduleData(EntitilementData);
                        break;

                    case "Capacity over min":
                        response = await fetchCurrentCapacityOverMin(dateToUse, solarModel, windModel);
                        const capacityData = response.data;
                        processCapacityOverMinData(capacityData);
                        break;

                    case "Total Min Schedule":
                        // response = await fetchDaMinSchedule(dateToUse, loadModel, priceModel, solarModel, windModel);
                        // setToalMinSchResponse(response);
                        // fetchPoolDetails(response);
                        // const MinData = response.data;
                        // processJsonPoolData(MinData, "ALL");
                        break;

                    case "Schedule Summary":
                        // response = await fetchDaEntSummary(dateToUse, loadModel, priceModel, solarModel, windModel);
                        // setEntitlementSummaryResponse(response);
                        // fetchPoolDetails(response);
                        // const EntitilementSummData = response.data;
                        // processJsonPoolData(EntitilementSummData, "ALL");
                        break;
                    case "Ramp_Capacity_master":
                        response = await fetchCurrentRampCapacityMaster(dateToUse, loadModel, priceModel, solarModel, windModel);
                        setRampCapacityMasterResponse(response);
                        fetchRampDetails(response);
                        const RampSummData = response.data;
                        processRampPoolData(RampSummData, "ALL");
                        break;
                    case "Merit Order ramp Up/Down":
                        // response = await fetchDaMod(dateToUse, solarModel, windModel, loadModel);
                        // const meritData = response.data;
                        // processMerirOrderJsonData(meritData);
                        break;

                    case "Trade":
                        break;

                    default:
                        //   console.warn("Invalid or unsupported map option selected.");
                        return;
                }

            } catch (error) {
                //   console.error("Error fetching data:", error);
            }
        } catch (error) {
            // console.error("API Error:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchPoolDetails = (response) => {

        setPoolOptions([]);

        const data = response.data;

        if (!Array.isArray(data) || data.length === 0) {
            // console.error("Invalid or empty data format");
            return;
        }

        const poolColumnExists = data.some(row => row.hasOwnProperty('pool'));

        if (poolColumnExists) {
            const uniquePools = [...new Set(data.map(row => row.pool))];

            setPoolOptions(["ALL", ...uniquePools]);
        } else {
            //    console.error("No pool column found in the data.");
        }
    };

    const fetchRampDetails = (response) => {
        const data = response?.data ?? [];

        if (!Array.isArray(data) || data.length === 0) {
            //    console.error("Invalid or empty data format");
            return;
        }

        const transformed = data.map(row => {
            const {
                date,
                datetime,
                block_no,
                unit_name,
                variable_cost,
                ...valueFields
            } = row;

            return {
                date,
                datetime,
                block_no,
                unit_name,
                variable_cost,
                values: valueFields,
            };
        });

        const allValueKeys = transformed.reduce((acc, item) => {
            Object.keys(item.values).forEach(key => acc.add(key));
            return acc;
        }, new Set());

        const uniqueValueKeys = Array.from(allValueKeys);

        // console.log("Unique value keys:", uniqueValueKeys);

        setPoolOptions(["ALL", ...uniqueValueKeys]);
    };

    const fetchTradeData = async () => {
        const tomorrow = getTomorrowDate();
        const dateToUse = tomorrow;
        // console.log(dateToUse);
        if (timeRange === "0D") {
            return;
        }
        try {
            setHeaders([]);
            setTableData([]);
            setXData([]);
            setYData([]);

            const loadModel = selectedLoadModel || "";
            const priceModel = selectedPriceModel || "";
            const solarModel = selectedSolarModel || "";
            const windModel = selectedWindModel || "";
            const transaction_cost = transactionCost || 0.0236;
            const trading_margin = tradingMargin || 0.20;

            let response = null;

            switch (selectedTradeTab) {
                case 0:
                    response = await fetchMinSchPositionMap(dateToUse, solarModel, windModel, loadModel);
                    if (response?.data && Array.isArray(response.data)) {
                        processMustSellData(response.data);
                    } else {
                        // console.error("No valid data received (case 0):", response?.data);
                    }
                    break;

                case 1:
                case 4:
                    const fetchFunc = selectedTradeTab === 1 ? fetchDaSalesTradeMaster : fetchDaReplacementOpp;
                    response = await fetchFunc(dateToUse, loadModel, windModel, solarModel, priceModel, transaction_cost, trading_margin);
                    if (response?.data && Array.isArray(response.data)) {
                        setRawTradeData(response.data);
                        if (isTransposed) {
                            processTradeDataView2(response.data);
                            setCurrentView("view2");
                        } else {
                            processTradeData(response.data);
                            setCurrentView("view1");
                        }
                    } else {
                        // console.error("No valid data received (case 1 or 4):", response?.data);
                    }
                    break;

                default:
                //  console.warn("No handler for this tab.");
            }

        } catch (error) {
            // console.error("Error fetching data:", error);
        }
    };

    const handleTradeCommit = async () => {
        try {
            let result = null;

            switch (selectedTradeTab) {
                case 0:
                    // result = await commitDaReplacementTrade(tableData);
                    break;
                case 1:
                    //  result = await commitLadderBidUnitsData(tableData);
                    break;
                case 2:
                    //  result = await commitLadderBidData(tableData);
                    break;
                case 3:
                    //  result = await commitBlockBidData(tableData);
                    break;
                case 4:
                    result = await commitDaReplacementTrade(tableData);
                    break;
                default:
                // console.warn("Invalid tab index for commit.");
            }
        } catch (error) {
            //  console.error("Commit error:", error);
        }
    };

    const processMerirOrderJsonData = (data) => {
        if (!Array.isArray(data) || data.length === 0) {
            //   console.error("Invalid or empty data format");
            return;
        }

        const unitNames = new Set();
        setHeaders([]);
        setTableData([]);
        setXData([]);
        setYData([]);

        data.forEach(row => {
            if (row.unit_name) unitNames.add(row.unit_name);
        });

        const groupedMap = new Map();

        data.forEach(row => {
            const dateValue = typeof row.date === "string" && row.date.includes("T")
                ? row.date.split("T")[0]
                : row.date;

            const key = `${dateValue}|${row.block_no}|${row.rev_no}`;
            if (!groupedMap.has(key)) {
                groupedMap.set(key, {
                    date: dateValue,
                    block_no: row.block_no,
                    rev_no: row.rev_no,
                    pool: row.pool,
                });
            }

            const currentRow = groupedMap.get(key);

            currentRow[row.unit_name] = Number(
                row.min_schedule ?? row.unit_mod_allocation
            ) || 0;
        });

        const processedData = Array.from(groupedMap.values());
        processedData.sort((a, b) => {
            const dateA = new Date(a.date), dateB = new Date(b.date);
            if (dateA - dateB !== 0) return dateA - dateB;
            if (a.block_no - b.block_no !== 0) return a.block_no - b.block_no;
            return (a.rev_no || 0) - (b.rev_no || 0);
        });
        const headersWithMetadata = [
            {
                name: "date",
                dataType: "date",
                editable: false,
                width: 150,
                displayName: "Date",
            },
            {
                name: "block_no",
                dataType: "number",
                editable: false,
                width: 100,
                displayName: "Block No",
            },
            ...Array.from(unitNames).map(unit => ({
                name: unit,
                dataType: "number",
                editable: true,
                width: 120,
                displayName: unit,
            })),
        ];

        setHeaders(headersWithMetadata);
        setTableData(processedData);
        const fieldNames = headersWithMetadata.map(h => h.name);
        prepareChartData(processedData, fieldNames);
    };

    const processMustSellData = (data) => {
        // console.log(data);
        if (!Array.isArray(data) || data.length === 0) {
            //  console.error("Invalid or empty data format");
            return;
        }

        setHeaders([]);
        setTableData([]);
        setXData([]);
        setYData([]);

        const processedData = data.map((row, idx) => {
            const date = row.date?.split("T")[0] || "";
            const blockNo = row.block_no;
            const demand = Number(row["demand_forecast"]);
            const mustSch = Number(row["must_sch_vol"]);

            if (isNaN(demand) || isNaN(mustSch)) {
                //  console.warn(`Skipping row ${idx} due to invalid values:`, { demand: row["demand_forecast"], mustSch: row["must_sch_vol"] });
                return null;
            }

            const mustSell = mustSch - demand;
            const mustSellDisplay = Math.max(mustSell, 0);

            return {
                date,
                block_no: blockNo,
                "Must Sell": mustSellDisplay,
            };
        }).filter(Boolean);

        if (processedData.length === 0) {
            // console.warn("No valid rows after processing Must Sell logic");
            setHeaders([]);
            setTableData([]);
            return;
        }

        const headersWithMetadata = [
            {
                name: "date",
                dataType: "date",
                editable: false,
                width: 120,
                displayName: "Date",
            },
            {
                name: "block_no",
                dataType: "number",
                editable: false,
                width: 100,
                displayName: "Block No",
            },
            {
                name: "Must Sell",
                dataType: "number",
                editable: true,
                width: 120,
                displayName: "Must Sell",
            }
        ];

        setHeaders(headersWithMetadata);
        setTableData(processedData);
        const fieldNames = headersWithMetadata.map(h => h.name);
        prepareChartData(processedData, fieldNames);
    };

    const processJsonData = (data) => {
        // console.log(data);
        if (!Array.isArray(data) || data.length === 0) {
            //  console.error("Invalid or empty data format");
            return;
        }

        setHeaders([]);
        setTableData([]);
        setXData([]);
        setYData([]);
        const nonEditableColumns = new Set(["Date", "Block No", "block_no"]);

        const allKeys = new Set();
        data.forEach(row => {
            Object.keys(row).forEach(key => {
                allKeys.add(key);
            });
        });

        const normalizedData = data.map(row => {
            const newRow = { ...row };
            allKeys.forEach(key => {
                let value = newRow[key];
                if (typeof value === "string" && value.match(/^\d{4}-\d{2}-\d{2}T/)) {
                    newRow[key] = value.split("T")[0];
                }
            });
            return newRow;
        });

        normalizedData.sort((a, b) => {
            const dateA = new Date(a.date), dateB = new Date(b.date);
            if (dateA - dateB !== 0) return dateA - dateB;
            if (a.block_no - b.block_no !== 0) return a.block_no - b.block_no;
            return (a.rev_no || 0) - (b.rev_no || 0);
        });

        const headersWithMetadata = Array.from(allKeys).map(key => {
            let sampleValue = normalizedData.find(d => d[key] !== undefined)?.[key];
            let dataType = typeof sampleValue;
            if (typeof sampleValue === "string" && sampleValue.match(/^\d{4}-\d{2}-\d{2}$/)) dataType = "date";
            else if (!isNaN(Number(sampleValue))) dataType = "number";

            return {
                name: key,
                dataType: dataType,
                editable: !nonEditableColumns.has(key),
                width: 120,
                displayName: key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()),
            };
        });

        setHeaders(headersWithMetadata);
        setTableData(normalizedData);
        const fieldNames = headersWithMetadata.map(h => h.name);
        prepareChartData(normalizedData, fieldNames);
    };

    const processScheduleData = (data) => {
        if (!Array.isArray(data) || data.length === 0) {
            // console.error("Invalid or empty data format:", data);
            return;
        }

        setHeaders([]);
        setTableData([]);
        setXData([]);
        setYData([]);

        const blockNos = [...new Set(data.map(row => row.block_no))];
        const dates = [...new Set(data.map(row => row.date?.split("T")[0]))].filter(Boolean);

        const unitScheduleTypes = {};
        const unitNamesWithValidSchedule = [...new Set(data.map(row => row.unit_name))].filter(unitName => {
            const entry = data.find(d =>
                d.unit_name === unitName &&
                d.schedule !== null &&
                d.schedule !== undefined &&
                d.schedule !== ""
            );
            if (entry) {
                unitScheduleTypes[unitName] = entry.schedule_type || "N/A";
                return true;
            }
            return false;
        });

        const rows = [];

        dates.forEach(date => {
            blockNos.forEach(blockNo => {
                const row = { date, block_no: blockNo };

                unitNamesWithValidSchedule.forEach(unitName => {
                    const entry = data.find(d =>
                        d.unit_name === unitName &&
                        d.block_no === blockNo &&
                        d.date?.split("T")[0] === date
                    );
                    row[unitName] = entry?.schedule ?? " ";
                });

                rows.push(row);
            });
        });

        rows.sort((a, b) => {
            const dateA = new Date(a.date), dateB = new Date(b.date);
            if (dateA - dateB !== 0) return dateA - dateB;
            if (a.block_no - b.block_no !== 0) return a.block_no - b.block_no;
            return (a.rev_no || 0) - (b.rev_no || 0);
        });
        const topHeader = [
            { name: 'block_no', displayName: 'schedule_type', editable: false },
            ...unitNamesWithValidSchedule.map(unit => ({
                name: unit,
                displayName: String(unitScheduleTypes[unit]),
                editable: false
            }))
        ];

        const secondHeader = [
            { name: 'block_no', displayName: 'Block No', editable: false },
            ...unitNamesWithValidSchedule.map(unit => ({
                name: unit,
                displayName: unit,
                editable: true
            }))
        ];

        setHeaders([topHeader, secondHeader]);
        setTableData(rows);
        prepareChartData(rows, unitNamesWithValidSchedule);
    };

    const processTradeData = (data) => {
        if (!Array.isArray(data) || data.length === 0) {
            //  console.error("Invalid or empty data format:", data);
            return;
        }

        setHeaders([]);
        setTableData([]);
        setXData([]);
        setYData([]);

        const blockNos = [...new Set(data.map(row => row.block_no))];
        const dates = [...new Set(data.map(row => row.date ? row.date.split("T")[0] : null))].filter(Boolean);

        const unitNames = [...new Set(data.map(row => row.unit_name))].filter(unitName => {
            const entry = data.find(d => d.unit_name === unitName);
            return entry?.bid_price !== null && entry?.bid_price !== undefined;
        });

        const unitBidPrices = {};
        unitNames.forEach(unitName => {
            const entry = data.find(d => d.unit_name === unitName);
            unitBidPrices[unitName] = entry?.bid_price;
        });

        const rows = [];

        dates.forEach(date => {
            blockNos.forEach(blockNo => {
                const row = { date, block_no: blockNo };

                unitNames.forEach(unitName => {
                    const entry = data.find(d =>
                        d.unit_name === unitName &&
                        d.block_no === blockNo &&
                        d.date?.split("T")[0] === date
                    );
                    row[unitName] = entry?.sale_vol ?? " ";
                });

                rows.push(row);
            });
        });

        const topHeader = [
            { name: 'block_no', displayName: 'Bid Price', editable: false },
            ...unitNames.map(unit => ({
                name: unit,
                displayName: unitBidPrices[unit],
                editable: false
            }))
        ];

        const secondHeader = [
            { name: 'block_no', displayName: 'Block No', editable: false },
            ...unitNames.map(unit => ({
                name: unit,
                displayName: unit,
                editable: true
            }))
        ];
        rows.sort((a, b) => {
            const dateA = new Date(a.date), dateB = new Date(b.date);
            if (dateA - dateB !== 0) return dateA - dateB;
            if (a.block_no - b.block_no !== 0) return a.block_no - b.block_no;
            return (a.rev_no || 0) - (b.rev_no || 0);
        });
        setHeaders([topHeader, secondHeader]);
        setTableData(rows);
        prepareChartData(rows, unitNames);
    };

    const processTradeDataView2 = (data) => {
        if (!Array.isArray(data) || data.length === 0) {
            //   console.error("Invalid or empty data format:", data);
            return;
        }

        setHeaders([]);
        setTableData([]);
        setXData([]);
        setYData([]);

        const blockNos = [...new Set(data.map(row => row.block_no))].sort((a, b) => a - b);
        const nonEditableColumns = new Set(["Date", "Block No", "block_no"]);
        const unitNames = [...new Set(data.map(row => row.unit_name))].filter(unitName => {
            const entry = data.find(d => d.unit_name === unitName);
            return entry?.bid_price !== null && entry?.bid_price !== undefined;
        });

        const rows = [];

        unitNames.forEach(unitName => {
            const row = { unit_name: unitName };
            const unitData = data.filter(row => row.unit_name === unitName);
            const bidPrice = unitData.length > 0 ? unitData[0].bid_price : null;

            blockNos.forEach(blockNo => {
                const blockData = unitData.find(row => row.block_no === blockNo);
                const saleVol = blockData?.sale_vol ?? null;
                row[`${blockNo} (Block ${blockNo})`] = saleVol;
            });

            row["bid_price"] = bidPrice;
            rows.push(row);
        });

        if (rows.length === 0) {
            //  console.warn("No rows to display in View 2.");
        }

        const headers = [
            { name: "bid_price", displayName: "Bid Price", editable: true },
            { name: "unit_name", displayName: "Unit Name", editable: true },
            ...blockNos.map(blockNo => ({
                name: `${blockNo} (Block ${blockNo})`,
                displayName: `${blockNo}`,
                editable: !nonEditableColumns.has('${blockNo} (Block ${blockNo})')
            }))
        ];

        setHeaders(headers);
        setTableData(rows);
        prepareChartData(rows, headers.map(h => h.name));
    };

    const fetchAllForecastModels = async () => {
        try {
            // Fetch Load Models
            fetchLoadModel()
                .then(response => {
                    const loadSet = new Set();
                    (response.data || []).forEach(item => {
                        if (item.model_name) loadSet.add(item.model_name);
                    });
                    setLoadModels(Array.from(loadSet));
                })
                .catch(error => {
                    // console.error("Load model fetch error:", error);
                });

            // Fetch Solar Models
            fetchSolarModel()
                .then(response => {
                    const solarSet = new Set();
                    (response.data || []).forEach(item => {
                        if (item.model_name) solarSet.add(item.model_name);
                    });
                    setSolarModels(Array.from(solarSet));
                })
                .catch(error => {
                    // console.error("Solar model fetch error:", error);
                });

            // Fetch Wind Models
            fetchWindModel()
                .then(response => {
                    const windSet = new Set();
                    (response.data || []).forEach(item => {
                        if (item.model_name) windSet.add(item.model_name);
                    });
                    setWindModels(Array.from(windSet));
                })
                .catch(error => {
                    //  console.error("Wind model fetch error:", error);
                });

            // Fetch Price Models
            fetchPriceModel()
                .then(response => {
                    const priceSet = new Set();
                    (response.data || []).forEach(item => {
                        if (item.model_name) priceSet.add(item.model_name);
                    });
                    setPriceModels(Array.from(priceSet));
                })
                .catch(error => {
                    //   console.error("Price model fetch error:", error);
                });

        } catch (err) {
            // console.error("Unexpected error:", err);
        }
    };

    return (
        <div className="positionmap-container" ref={dropdownRef}>
            {loading && (
                <div className="dashboard-loading-bar"></div>
            )}
            <div className="top-bar">
                <div className="date-picker">
                    <input
                        id="date-input"
                        type="date"
                        value={selectedDate}
                        onChange={(e) => setSelectedDate(e.target.value)}
                        placeholder=" "
                    />
                </div>

                <div className="dropdown-container">
                    <button
                        onClick={() => toggleDropdown("map")}
                        className="dropdown-button"
                    >
                        {selectedMapOption} {openDropdown === "map" ? <IoMdArrowDropup /> : <IoMdArrowDropdown />}
                    </button>

                    {openDropdown === "map" && (
                        <div className="dropdown-menus-position">
                            {(timeRange === "0D" ? mapOptions0D : mapOptions1D).map((option, index) => (
                                <div
                                    key={index}
                                    onClick={() => handleSelect(option, "map")}
                                    className={`dropdown-item ${selectedMapOption === option ? "selected" : ""}`}
                                >
                                    {option}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
            <br />
            {statusMessage && (
                <div className={`status-message ${messageType}`}>
                    {statusMessage}
                </div>
            )}
            {selectedMapOption !== "Trade" && (
                <div className="data-bar">
                    <div className="left-section">
                        <span
                            onClick={() => setShowTable(!showTable)}
                            className="toggle-view"
                        >
                            {showTable ? <FaChartBar size={24} /> : <FaTableCells size={24} />}
                        </span>

                        <button className="position-optimize-button" onClick={openSettingsModal}>
                            <IoMdPlayCircle className="button-icon" size={24} />
                        </button>
                        <button className="position-refresh-button" onClick={fetchData}>
                            <MdOutlineRefresh className="button-icon" size={24} />
                        </button>
                        {poolOptions.length > 0 && (
                            <div className="dropdown-container">
                                <select
                                    id="pool-select"
                                    className="dropdown-button"
                                    onChange={(e) => handlePoolChange(e.target.value)}
                                    defaultValue="ALL"
                                >
                                    {poolOptions.map((pool, index) => (
                                        <option key={index} value={pool}>
                                            {pool}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}

                    </div>

                    <div className="right-section">
                        <div className="time-range-tabs">
                            {["0D", "1D"].map(range => (
                                <button
                                    key={range}
                                    className={timeRange === range ? "active" : ""}
                                    onClick={() => {
                                        setTimeRange(range);
                                        setPoolOptions([]);
                                        if (range === "1D") {
                                            const tomorrow = getTomorrowInIST();
                                            setSelectedDate(tomorrow);
                                            setSelectedMapOption(mapOptions1D[0]);
                                            fetchData1D(range, tomorrow);
                                        } else if (range === "0D") {
                                            const today = getTodayInIST();
                                            setSelectedDate(today);
                                            setSelectedMapOption(mapOptions0D[0]);
                                            fetchData0D(range, today);
                                        }
                                    }}
                                >
                                    {range}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
            )}

            {selectedMapOption === "Trade" && (
                <div className="trade-container">
                    {/* Tabs row */}
                    <div className="trade-tabs">
                        {["Must-Sell", "Ladder-Bid-units", "Ladder-Bid", "Block-Bid", "Replacement Opportunity"].map((tab, index) => (
                            <button
                                key={index}
                                className={`trade-tab ${selectedTradeTab === index ? "active" : ""}`}
                                onClick={() => {
                                    setHeaders([]);
                                    setTableData([]);
                                    setXData([]);
                                    setYData([]);

                                    setSelectedTradeTab(index);
                                }}
                            >
                                {tab.toUpperCase()}
                            </button>
                        ))}
                    </div>

                    {/* Controls row */}
                    <div className="trade-controls">
                        <div className="left-controls">
                            <span
                                onClick={() => setShowTable(!showTable)}
                                className="toggle-view"
                            >
                                {showTable ? <FaChartBar size={24} /> : <FaTableCells size={24} />}
                            </span>
                            {(selectedTradeTab === 1 || selectedTradeTab === 4) && (
                                <label className="transpose-toggle">
                                    <input
                                        type="checkbox"
                                        checked={isTransposed}
                                        onChange={(e) => {
                                            const newValue = e.target.checked;
                                            setIsTransposed(newValue);

                                            if (rawTradeData.length > 0) {
                                                if (newValue) {
                                                    processTradeDataView2(rawTradeData);
                                                    setCurrentView('view2');
                                                } else {
                                                    processTradeData(rawTradeData);
                                                    setCurrentView('view1');
                                                }
                                            }
                                        }}
                                    />
                                    <span className="slider" />
                                    <span className="label-text">Transpose *</span>
                                </label>
                            )}

                            {/* <button className="position-optimize-button" onClick={() => setShowSettingModal(true)}>
                                <IoMdPlayCircle className="button-icon" /> SETTINGS
                            </button> */}
                            <button className="commits-button" onClick={handleTradeCommit}>
                                <MdCloudUpload className="button-icon" size={24} />
                            </button>
                            <button className="position-refresh-button" onClick={fetchTradeData}>
                                <MdOutlineRefresh className="button-icon" size={24} />
                            </button>
                        </div>
                        <div className="right-section">
                            {/* <div className="time-range-buttons">
                                {["0D", "1D"].map(range => (
                                    <button
                                        key={range}
                                        className={timeRange === range ? "active" : ""}
                                        onClick={() => {
                                            setTimeRange(range);
                                            setPoolOptions([]);
                                            if (range === "1D") {
                                                const tomorrow = getTomorrowInIST();
                                                setSelectedDate(tomorrow);
                                                fetchTradeData();
                                            } else if (range === "0D") {
                                                const today = getTodayInIST();
                                                setSelectedDate(today);
                                                // fetchTradeData();
                                            }
                                        }}
                                    >
                                        {range}
                                    </button>
                                ))}
                            </div> */}

                                   <div className="time-range-tabs">
                            {["0D", "1D"].map(range => (
                                <button
                                    key={range}
                                    className={timeRange === range ? "active" : ""}
                                    onClick={() => {
                                        setTimeRange(range);
                                        setPoolOptions([]);
                                        if (range === "1D") {
                                             const tomorrow = getTomorrowInIST();
                                                setSelectedDate(tomorrow);
                                                fetchTradeData();
                                        } else if (range === "0D") {
                                            const today = getTodayInIST();
                                                setSelectedDate(today);
                                                // fetchTradeData();
                                        }
                                    }}
                                >
                                    {range}
                                </button>
                            ))}
                        </div>
                        </div>
                    </div>
                </div>
            )}

            {showTable ? (
                tableData.length > 0 ? (
                    selectedMapOption === "Schedule Master" && timeRange === "0D" ? (
                        <TradeTable
                            ref={tableRef}
                            headers={headers}
                            rows={tableData}
                            edit={true}
                            sorting={true}
                            drag={true}
                            filtering={true}
                            exporting={true}
                            addRow={false}
                            restrictEditToNewRows={false}
                        />
                    ) : selectedMapOption === "Trade" &&
                        currentView === "view1" &&
                        (selectedTradeTab === 1 || selectedTradeTab === 4) ? (
                        <TradeTable
                            ref={tableRef}
                            headers={headers}
                            rows={tableData}
                            edit={true}
                            sorting={true}
                            drag={true}
                            filtering={true}
                            exporting={true}
                            addRow={false}
                            restrictEditToNewRows={false}
                        />
                    ) : (
                        <Table
                            ref={tableRef}
                            headers={headers}
                             maxHeight="550px"
                            rows={tableData}
                            edit={true}
                            sorting={true}
                            drag={true}
                            filtering={true}
                            exporting={true}
                            addRow={false}
                            restrictEditToNewRows={false}
                            onDeleteAllClick={handleDeleteAll}
                        />
                    )
                ) : null
            ) : xData.length > 0 && yData.length > 0 ? (
                selectedMapOption === "Position map" ? (
                    <CombinationCharts
                        ref={chartRef}
                        xData={xData}
                        yData={yData}
                        drag={true}
                        edit={true}
                    />
                ) : (
                    <StackedBarCharts
                        ref={chartRef}
                        xData={xData}
                        yData={yData}
                        drag={true}
                        edit={true}
                    />
                )
            ) : null}
        {showSettingModal && (
  <div className="positionmap-modal-overlay">
    <div className="positionmap-modal">
      <div className="positionmap-modal-header">
        <h3>Settings</h3>
        <button onClick={() => setShowSettingModal(false)}>✖</button>
      </div>
      <div className="positionmap-modal-body">

                            <div className="dropdown">
                                <label htmlFor="loadForecast">Load Forecast</label>
                                <select id="loadForecast" value={tempLoadModel} onChange={(e) => setTempLoadModel(e.target.value)}>
                                    {loadModels.map((model, index) => (
                                        <option key={index} value={model}>{model}</option>
                                    ))}
                                </select>
                            </div>

                            <div className="dropdown">
                                <label htmlFor="priceForecast">Price Forecast</label>
                                <select
                                    id="priceForecast"
                                    value={tempPriceModel || ""}
                                    onChange={(e) => setTempPriceModel(e.target.value)}
                                >
                                    {priceModels.map((model, index) => (
                                        <option key={index} value={model}>{model}</option>
                                    ))}
                                </select>
                            </div>

                            <div className="dropdown">
                                <label htmlFor="solarForecast">Solar Forecast</label>
                                <select id="solarForecast" value={tempSolarModel} onChange={(e) => setTempSolarModel(e.target.value)}>
                                    {solarModels.map((model, index) => (
                                        <option key={index} value={model}>{model}</option>
                                    ))}
                                </select>
                            </div>

                            <div className="dropdown">
                                <label htmlFor="windForecast">Wind Forecast</label>
                                <select id="windForecast" value={tempWindModel} onChange={(e) => setTempWindModel(e.target.value)}>
                                    {windModels.map((model, index) => (
                                        <option key={index} value={model}>{model}</option>
                                    ))}
                                </select>
                            </div>

                            <div className="input-group">
                                <label htmlFor="transactionCost">Transaction Cost</label>
                                <input
                                    type="text"
                                    id="transactionCost"
                                    value={tempTransactionCost}
                                    onChange={(e) => handleTempNumericInput(e, setTempTransactionCost)}
                                    placeholder="Enter transaction cost"
                                />
                            </div>

                            <div className="input-group">
                                <label htmlFor="tradingMargin">Trading Margin</label>
                                <input
                                    type="text"
                                    id="tradingMargin"
                                    value={tempTradingMargin}
                                    onChange={(e) => handleTempNumericInput(e, setTempTradingMargin)}
                                    placeholder="Enter trading margin"
                                />
                            </div>

                            <div className="button-container">
                                <button className="settings-save-button" onClick={handleSaveSettings}>Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}


            {/* {(showTable || (!showTable && xData.length > 0)) && (
                <div className="positionMap-menu">
                    <div className="time-range-buttons">
                        {["0D", "1D"].map(range => (
                            <button
                                key={range}
                                className={timeRange === range ? "active" : ""}
                                onClick={() => {
                                    setTimeRange(range);
                                    setPoolOptions([]);
                                    if (range === "1D") {
                                        const tomorrow = getTomorrowInIST();
                                        setSelectedDate(tomorrow);
                                        setSelectedMapOption(mapOptions1D[0]);
                                        fetchData1D(range, tomorrow);
                                    } else if (range === "0D") {
                                        const today = getTodayInIST();
                                        setSelectedDate(today);
                                        setSelectedMapOption(mapOptions0D[0]);
                                        fetchData0D(range, today);
                                    }
                                }}
                            >
                                {range}
                            </button>
                        ))}
                    </div>
                </div>
            )} */}
        </div>
    );
};

export default Positionmap;